<template>
    <v-row class="ma-0 pb-offset">
		<v-col class="pa-0 pb-4" cols="12">
			<v-card elevation="1" class="background-2 round-card">
                <v-card-title class="pa-3">
                    <p class="pl-2 pl-xl-3">DDT</p>
                </v-card-title>                    
                <v-divider></v-divider>
                <v-container class="pa-0" fluid>
                    <v-row class="pa-4">
                        <v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6" >
                            <v-switch
                                type="number"
                                label="Attiva gestione competenza"
                                v-model="settings['enable_competence']"
                                :error-messages="errors.collect('Gestione Competenza')"
                                :data-vv-name="'Gestione Competenza'"
								inset
                            ></v-switch>
                        </v-col>
                        <v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6" >
                            <v-switch
                                label="Avviso frequenze di fatturazione miste"
                                v-model="settings['check_invoice_frequency']"
                                hint="Alla generazione documenti, avvisa se i DDT selezionati appartengono a clienti con frequenze di fatturazione diverse"
                                persistent-hint
								inset
                            ></v-switch>
                        </v-col>
                        <v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6" >
                            <v-switch
                                label="Reso da cliente come DDT di acquisto (vecchio flusso)"
                                v-model="settings['legacy_customer_return']"
                                hint="Dal DDT di vendita il reso crea un DDT di acquisto invece di un DDT di vendita con causale di carico"
                                persistent-hint
								inset
                            ></v-switch>
                        </v-col>
                    </v-row>
                </v-container>
                <v-divider></v-divider>
                <v-card-actions class="pr-4">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click.native="saveSettings">Salva</v-btn>
                </v-card-actions>
                        
            </v-card>
		</v-col>
		<v-col class="pa-0 pt-4" cols="12">
			<numbering-check-settings
				model-name="ddt"
				document-label="i DDT"
			/>
		</v-col>
		<v-col class="pa-0 pt-4" cols="12">
			<crud
				title="Causali documento"
				action-icon='settings'
				model-def='generaltypes-document_causal'
				action-position='absolute'
				crudDialog
			></crud>
		</v-col>
		<v-col class="pa-0 pt-4" cols="12">
			<crud
				title="Causali di trasporto"
				action-icon='settings'
				model-def='generaltypes-ddt_purpose'
				action-position='absolute'
				crudDialog
			></crud>
		</v-col>
		<v-col class="pt-4 pa-0" cols="12">
			<crud
				title="Aspetto dei beni"
				action-icon='settings'
				model-def='generaltypes-ddt_appearance'
				action-position='absolute'
				crudDialog
			></crud>
		</v-col>
		<v-col class="pt-4 pa-0" cols="12">
			<crud
				title="Porti"
				action-icon='settings'
				model-def='generaltypes-ddt_port'
				action-position='absolute'
				crudDialog
			></crud>
		</v-col>
		<v-col class="pt-4 pa-0" cols="12">
			<crud
				title="Trasporto a mezzo"
				action-icon='settings'
				model-def='generaltypes-ddt_transport_by'
				action-position='absolute'
				crudDialog
			></crud>
		</v-col>
	</v-row>
</template>

<script>
	import SettingsOptionsMixin from '@/mixins/SettingsOptionsMixin'
	import NumberingCheckSettings from '@/components/common/NumberingCheckSettings'

	export default {
		name:'ddts-other',
		components: {
			NumberingCheckSettings
		},
		mixins: [SettingsOptionsMixin],
		data() {
			return {
				model: 'ddt',
				settings: {
					'enable_competence': false,
					'check_invoice_frequency': false,
					'legacy_customer_return': false
				}
			}
		}
	}
  </script>
